/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import { Grid, Typography, makeStyles, IconButton } from "@material-ui/core";
import { Done, Clear } from "@material-ui/icons";
import Actions from "../../../fluid/Actions/ActionFactory";
import { InputField, BoxContainer } from "../FormFields";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  mainContainer: {
    padding: "20px",
    height: "calc(100vh - 95px)",
    overflow: "hidden",
  },
  topContainer: {
    background: "#FFFFFF",
    padding: "20px",
    margin: "10px 0px",
    boxShadow: "0px 3px 6px #00000029",
    height: "40%",
  },
  headerField: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  titleText: {
    color: "#222222",
    fontSize: "18px",
    fontWeight: "bold",
  },

  boxWrapper: {
    height: "58%",
  },
  filedBox: {
    width: "49%",
    height: "100%",
  },
  formField: {
    width: "49%",
  },
}));

const EditUser = ({
  prevData,
  setIsEditUser,
  setIsTableUpdated,
  setisEdited,
}) => {
  const classes = useStyles();
  const [userData, setUserData] = useState(prevData);
  const [groupsList, setGroupsList] = useState(prevData?.groups);
  const [rolesList, setRolesList] = useState(prevData?.rolesList);
  const [open, setopen] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  const [disable, setdisable] = useState(false);

  const handleChange = (event) => {
    // console.log("eeee", event.target.value);
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleSubmit = () => {
    const params = {
      name: userData.name,
      email: userData.email,
      description: userData.description,
      groups: groupsList.map((group) => {
        return {
          name: group.name,
        };
      }),
    };
    console.log("user...", params);
    Actions("http_request", {
      url: "/sainapse/user/" + prevData.email,
      method: "put",
      data: params,
    })
      .then((res) => {
        console.log("res..1", res.data);
        setIsTableUpdated(true);
        setUserData({ name: "", email: "", description: "" });
        setGroupsList([]);
        setIsEditUser(false);
        setisEdited(true);
      })
      .catch((err) => {
        console.log("err..", err.message);
        setopen(true);
        seterrmsg(err);
      });
  };
  const onClose = () => {
    setopen(false);
    seterrmsg(null);
  };
  useEffect(() => {
    console.log("Editing User Data : ", userData)
    if (userData.name !== "" && userData.email !== "") {
      setdisable(false);
    } else {
      setdisable(true);
    }
    if (
      userData.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
    ) {
      setdisable(true);
    }
  }, [userData]);
  return (
    <Grid container className={classes.mainContainer}>
      <Grid container className={classes.topContainer}>
        <Grid item className={classes.headerField}>
          <div>
            <Typography className={classes.titleText}>Editing User</Typography>
          </div>
          <div>
          <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/user/{email}",
                        method : "PUT",
                        operands : [
                          {
                            attrName: "email",
                            value : userData.email
                      }]
                      }}
                  >
              <IconButton
                onClick={handleSubmit}
                style={{
                  color: disable ? "#62666e" : "#0CD02A",
                }}
                disabled={disable}
              >
                <Done />
              </IconButton>
            </SecureWrapper>
            <IconButton
              style={{
                color: "#FF0000",
              }}
              onClick={() => setIsEditUser(false)}
            >
              <Clear />
            </IconButton>
          </div>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid item className={classes.formField}>
            <InputField
              name="name"
              size="small"
              placeholder="Name"
              value={userData?.name}
              onChange={(e) => handleChange(e)}
              fullWidth
              helperText={
                userData.name === "" ? "* This Field is Required" : ""
              }
              error={userData.name === "" ? true : false}
            />
          </Grid>
          <Grid item className={classes.formField}>
            <InputField
              name="email"
              size="small"
              placeholder="Email"
              value={userData?.email}
              onChange={(e) => handleChange(e)}
              fullWidth
              helperText={
                userData.email === ""
                  ? "* This Field is Required "
                  : userData.email &&
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                      userData.email
                    )
                  ? "* Please Enter Valid Email id"
                  : ""
              }
              error={
                userData.email === "" ||
                (userData.email &&
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    userData.email
                  ))
                  ? true
                  : false
              }
              disabled = {userData.email.length > 0 ? true : false}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <InputField
            name="description"
            size="large"
            placeholder="Description"
            value={userData?.description}
            onChange={(e) => handleChange(e)}
            fullWidth
            multiline
            rows={8}
          />
        </Grid>
      </Grid>
      <Grid
        container
        style={{ display: "flex", justifyContent: "space-between" }}
        className={classes.boxWrapper}
      >
        <Grid item className={classes.filedBox}>
          <BoxContainer
            userType="exist"
            title="Groups"
            leftBox={groupsList}
            setLeftBox={setGroupsList}
          />
        </Grid>
      </Grid>
      {open && (
        <ErrorMessageAlert
          open={open}
          errorInfo={errmsg}
          handleClose={onClose}
        />
      )}
    </Grid>
  );
};

export default EditUser;
